<template>
    <div class="start-with-success-area pt-100 bg-f8f9f8 pb-70">
        <div class="container">
            <div class="section-title" v-for="title of titles" :key="title.title_id">
                <span class="sub-title">{{ title.title_title }}</span>
                <h2>{{ title.title_header }}</h2>
                <p>{{ title.title_content }}</p>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6 col-sm-6" v-for="teacher of teachers" :key="teacher.teacher_id">
                    <div class="start-with-success-box">
                        <div class="image">
                            <div to="/success-story">
                                <img :src="getImgUrl('ogretmenler', teacher.teacher_img)" :alt="teacher.teacher_name">
                            </div>
                        </div>
                        <div class="content">
                            <h3>{{ teacher.teacher_name }}</h3>
                            <span>{{ teacher.teacher_profession }}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: 'StartWithSuccess',
    props: ['pathUrl'],



    created() {
        this.getTitles();
        this.getTeachers();
    },
    data() {
        return {
            titles: [],
            teachers: [],
            errors: []
        };
    },
    methods: {
        getTitles() {
            axios.get(this.pathUrl + "?data=title&parent=12")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getTeachers() {
            axios.get(this.pathUrl + "?data=teacher")
                .then(response => (this.teachers = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        }
    }
}
</script>